import { FC } from 'react';
import { BoundUserRow } from './BoundAccountsTable';
import { DefaultCell, TwoLinesCell } from '@silverfort/sf-components';

type Props = Pick<BoundUserRow, 'name'>;

const BoundUserNameCell: FC<Props> = ({ name }) => {
    return (
        <div className="flex items-center">
            {name.userName ? (
                <TwoLinesCell topText={name.fullName} bottomText={name.userName} />
            ) : (
                <DefaultCell text={name.fullName} />
            )}
        </div>
    );
};

export default BoundUserNameCell;
